module.exports = __webpack_public_path__ + "img/特大暴雨.9afb459a.png";